// Mount add-on (Michael 2026-09-21): the print is mounted to Sintra or Dibond INSIDE the
// frame. The substrate IS the backing — glass size — replacing the adhesive foam (Straight
// Fit / Shadow Box), the acid-free backing (Matted) or the foam under a float's matboard.
// STAFF ONLY for now ($xxlAdmin): it is nearly always a custom request. Priced by the
// backend (utils/pricing/frameMountPricing.ts) by glass size on the mount sheet tiers.
// NOT the mount-only product and NOT the float sintra platform (automatic at 36x48+).
export type FrameMountOption = {
  key: "standard" | "sintra" | "dibond";
  label: string;
  /** Stored at frameOptions.mount.type; "" = standard backing (stored as null). */
  type: string;
  description: string;
};

export const FRAME_MOUNT_OPTIONS: FrameMountOption[] = [
  {
    key: "standard",
    label: "Standard",
    type: "",
    description: "Standard backing for this treatment",
  },
  {
    key: "sintra",
    label: '1/8" Sintra',
    type: '1/8" Sintra',
    description: 'Print mounted to 1/8" Sintra as the backing',
  },
  {
    key: "dibond",
    label: "Dibond",
    type: "Dibond",
    description:
      "Print mounted to Dibond as the backing — rigid, keeps large pieces flat",
  },
];

// Largest substrate sheet. Same list as the backend / quote tool.
const MOUNT_MAX_SHEET: [number, number] = [60, 96];

/** Sintra / Dibond only when the GLASS fits the 60x96 sheet (either orientation). */
export function frameMountFits(glassWidth: number, glassHeight: number) {
  return (
    Math.min(glassWidth, glassHeight) <= MOUNT_MAX_SHEET[0] &&
    Math.max(glassWidth, glassHeight) <= MOUNT_MAX_SHEET[1]
  );
}

/** "" | '1/8" Sintra' | "Dibond" — read from a line's frameOptions. */
export function frameMountType(frameOptions: any): string {
  const t = String(frameOptions?.mount?.type ?? "").toLowerCase();
  return t.includes("dibond")
    ? "Dibond"
    : t.includes("sintra")
      ? '1/8" Sintra'
      : "";
}
